import { Session } from '@eventbrite/checkout-fairy-api';
import { getFormattedDateTime } from '@eventbrite/datetime-fns';
import { Icon } from '@eventbrite/eds-icon';
import { CalendarCheckMarkChunky } from '@eventbrite/eds-iconography';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';

import React, { FunctionComponent } from 'react';

import { gettext } from '@eventbrite/i18n';
import defaultStyles from './DateReminder.module.scss';
import rebrandStyles from './DateReminder.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export interface DateReminderProps extends Pick<Session, 'startDatetime'> {
    locale?: string;
    timezone?: string;
    isAppRebrandActive: boolean;
}

export const DateReminder: FunctionComponent<DateReminderProps> = ({
    locale,
    startDatetime,
    timezone,
    isAppRebrandActive,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    const content = getFormattedDateTime(
        startDatetime,
        !isAppRebrandActive,
        timezone,
        locale,
        isAppRebrandActive ? 'iii, MMM d・h:mmaaa' : 'iiii, MMMM d・h:mmaaa',
    );

    const icon = isAppRebrandActive ? null : (
        <Icon
            size="small"
            type={<CalendarCheckMarkChunky />}
            color="grey-900"
        />
    );

    const ariaLabel = gettext('Selected session: %(dateAndTime)s', {
        dateAndTime: content,
    }).toString();

    return (
        <div
            className={styles.dateReminder}
            data-testid="date-reminder"
            aria-label={ariaLabel}
        >
            <div className={styles.wrapper}>
                {icon}
                <span className={styles.date}>{content}</span>
            </div>
        </div>
    );
};
